import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = (_, { palette = {} }) => ({
  button: {
    '&.btn': {
      fontSize: '14px',
      border: 'none',
      height: 56,
      paddingLeft: 8,
      paddingRight: 8,
      marginLeft: 4,
      flex: '0 0 auto',

      '& .iconba': {
        fontSize: '16px',
        color: palette.themePrimary,
        marginRight: '8px',
        paddingBottom: '5px', // align to link
      },
    },
  },
  buttonGray: {
    '&.btn': {
      backgroundColor: palette.neutralLighter,

      '&:hover': {
        backgroundColor: palette.neutralLight,
      },
      '&:focus': {
        backgroundColor: palette.neutralQuaternaryAlt,
        '&:hover': {
          backgroundColor: palette.neutralQuaternary,
        },
      },
    },
  },
});

class AddFilterButtonUnthemed extends React.PureComponent {
  render() {
    return (
      <Button
        disabled={this.props.disableAdd}
        key="add filter"
        onClick={this.props.onClick}
        className={classNames(
          'add-filter-button',
          this.props.classes.button,
          this.props.isGrayCommandBar ? this.props.classes.buttonGray : null
        )}
      >
        <Glyphicon glyph="ba-Add" />
        {this.props.i18n.getString(_TL_('Add filter')) }
      </Button>
    );
  }
}

AddFilterButtonUnthemed.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    button: PropTypes.string.isRequired,
    buttonGray: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  disableAdd: PropTypes.bool,
  isGrayCommandBar: PropTypes.bool,
};

AddFilterButtonUnthemed.defaultProps = {
  disableAdd: false,
  isGrayCommandBar: false,
};


export const AddFilterButton =
  withDefaultStyles(AddFilterButtonUnthemed, getStyles);
